import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-5\" id=\"reset-side-paddings\"><a href=\"#reset-side-paddings\"></a> Reset Side Paddings </h1><div class=\"py-5\"> Add <code>.card-px-0</code> to reset a card header, body and footer&#39;s side paddings: </div><div class=\"py-5\"><div class=\"card card-px-0 shadow\"><div class=\"card-header\"><h3 class=\"card-title\">Title</h3><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-sm btn-light\"> Action </button></div></div><div class=\"card-body\"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry&#39;s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. </div><div class=\"card-footer\"> Footer </div></div></div>", 3)
const _hoisted_5 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`
        <div class="card card-px-0">
          <div class="card-header">
            <h3 class="card-title">Title</h3>
            <div class="card-toolbar">
              <button type="button" class="btn btn-sm btn-light">
                Action
              </button>
            </div>
          </div>
          <div class="card-body">
            Lorem Ipsum is simply dummy text...
          </div>
          <div class="card-footer">
            Footer
          </div>
        </div>
        `), 1)
        ]),
        _: 1
      })
    ])
  ]))
}